import { render, staticRenderFns } from "./CreateIconText.vue?vue&type=template&id=3b6bb018"
import script from "./CreateIconText.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateIconText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6bb018')) {
      api.createRecord('3b6bb018', component.options)
    } else {
      api.reload('3b6bb018', component.options)
    }
    module.hot.accept("./CreateIconText.vue?vue&type=template&id=3b6bb018", function () {
      api.rerender('3b6bb018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/CreateIconText.vue"
export default component.exports